import { Field } from '@atlassian/learning-components';
import React from 'react';

import { ContentfulSmCourse } from 'src/graphql/queries/GetSmCourse';
import { TagList } from 'src/components/TagList';

export const remapCourseTaxonomy = (course: ContentfulSmCourse, duration: string): Field[] => [
  {
    name: 'duration',
    value: duration,
  },
  {
    name: 'role',
    value: course.productRole?.length ? course.productRole.join(', ') : '',
  },
  {
    name: 'level',
    value: course.learningLevel,
  },
  {
    name: 'app',
    value: <TagList isLarge={false} taxonomyList={course.product} />,
  },
];
